import SearchResult from './SearchResult';
import ResultItem from './ResultItem';

class SearchService {
    constructor(fetcher) {
        this.fetcher = fetcher;

        this.totalResults = 0;
        this.items = [];
        this.amount = 15;
        this.query = '';
    }

    getResults(query, loadMore = false) {
        const start = loadMore ? this.items.length : 0;
        if (!loadMore) {
            this.items = [];
            this.totalResults = 0;
        }
        return this.fetcher.getResults(query, start, this.amount)
            .then((json) => {
                if (json && json.results) {
                    this.totalResults = +json.total;
                    const newItems = json.results.map(SearchService.convertJsonToResult);
                    this.items = [...this.items, ...newItems];
                }

                return new SearchResult(this.items, this.totalResults);
            });
    }

    static convertJsonToResult(item) {
        let title = item.document.title;
        let body = item.document.teaser;
        let image = item.document.image;

        if (item.highlights) {
            if (item.highlights.intro && item.highlights.intro[0]) {
                body = '...' + item.highlights.intro[0] + '...';
            } else if (item.highlights.body && item.highlights.body[0]) {
                body = '...' + item.highlights.body[0] + '...';
            }
        }

        if (body) {
            body = body.replace('<em>', '<strong>');
            body = body.replace('</em>', '</strong>');
        }

        if (title) {
            title = title.replace('<em>', '');
            title = title.replace('</em>', '');
        }

        return new ResultItem(
            title,
            item.document.url,
            body,
            image,
        );
    }
}

export default SearchService;
